var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 1000,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        maskClosable: false,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "title",
                            label: "活动名称",
                            required: "",
                          },
                        },
                        [
                          _c("a-input", {
                            style: { width: "206px" },
                            attrs: { placeholder: "请输入活动名称" },
                            model: {
                              value: _vm.model.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "title", $$v)
                              },
                              expression: "model.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "acDateRange",
                            label: "活动时间",
                            required: "",
                          },
                        },
                        [
                          _c("a-range-picker", {
                            style: { width: "206px" },
                            attrs: { value: _vm.model.acDateRange },
                            on: { change: _vm.onRangeChange },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "ant-form-item-required-71",
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "gradeId",
                            label: "活动范围",
                          },
                        },
                        [
                          _c("j-dict-select-tag", {
                            style: { width: "206px" },
                            attrs: {
                              dictCode:
                                "school_grade,grade_name,id,delete_flag=0",
                              "extra-options": [{ value: "", text: "全校" }],
                              placeholder: "请选择年级",
                            },
                            on: { clear: _vm.onGradeClear },
                            model: {
                              value: _vm.model.gradeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "gradeId", $$v)
                              },
                              expression: "model.gradeId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "picUrl",
                            label: "活动封面",
                            required: "",
                          },
                        },
                        [
                          _c("j-image-upload", {
                            attrs: { text: "上传活动图片", isMultiple: true },
                            model: {
                              value: _vm.model.picUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "picUrl", $$v)
                              },
                              expression: "model.picUrl",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "visible",
                            label: "家长可见",
                            required: "",
                          },
                        },
                        [
                          _c("j-dict-select-tag", {
                            style: { width: "206px" },
                            attrs: { dictCode: "visible_status" },
                            model: {
                              value: _vm.model.visible,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "visible", $$v)
                              },
                              expression: "model.visible",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 15 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "", prop: "content" } },
                        [
                          _c("WangEditor", {
                            staticStyle: {
                              margin: "2px",
                              border: "1px solid #d9d9d9",
                              "border-radius": "4px",
                              overflow: "hidden",
                            },
                            attrs: { editorStyle: { minHeight: "200px" } },
                            model: {
                              value: _vm.model.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "content", $$v)
                              },
                              expression: "model.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }